import http from '@services/http'
import { IShopInfo, IBuyProduct, IInappPurchased, IInappConsumed } from '@protocol/shop'

export default {
  getShopInfo(data: IShopInfo.Params): Promise<IShopInfo.Schema> {
    return http.get('shop/info', data || {})
  },

  buyProduct(data: IBuyProduct.Params): Promise<IBuyProduct.Schema> {
    return http.post('shop/buyProduct', data || {})
  },

  inappPurchased(data: IInappPurchased.Params): Promise<IInappPurchased.Schema> {
    return http.post('shop/inappPurchased', data || {})
  },

  inappConsumed(data: IInappConsumed.Params): Promise<IInappConsumed.Schema> {
    return http.post('shop/inappConsumed', data || {})
  },
}
